import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { isStrict, isAdmin } from 'selectors/user';
import { isFetching, data } from 'selectors/cottages';
import * as cottageSelectors from 'selectors/cottage';
import { fetchCottagesRequest } from 'actions/cottages';
import { updateCottageRequest, removeCottageRequest } from 'actions/cottage';
import Errors from 'components/shared/Errors';
import Main from 'components/templates/Main';
import moment from 'logic/moment';
import Cottages from '../components/CottagesList';

const CottagesContainer = () => {
  const dispatch = useDispatch();
  const cottages = useSelector(data);
  const errors = useSelector(cottageSelectors.error);
  const isLoading = useSelector(isFetching);
  const _isStrict = useSelector(isStrict);
  const updatingDialogs = useSelector(cottageSelectors.updatingDialogs);
  const _isAdmin = useSelector(isAdmin);

  React.useEffect(() => {
    if (!isLoading) {
      dispatch(fetchCottagesRequest());
    }
  }, []);

  const onActivate = (cottageId, isActive) => {
    dispatch(
      updateCottageRequest({
        cottageId,
        dialog: 'onActivate',
        values: {
          hidden_at: isActive ? null : moment().toISOString(),
        },
        updateCottages: true,
      }),
    );
  };

  const onRemove = (cottageId) => {
    dispatch(removeCottageRequest({ cottageId }));
  };

  return (
    <Main title={<FormattedMessage id="myListings" defaultMessage="My listings" />}>
      <Cottages
        cottages={cottages}
        updatingDialogs={updatingDialogs}
        isCanUse={!!_isAdmin}
        isStrict={_isStrict}
        isLoading={isLoading}
        onActivate={onActivate}
        onRemove={onRemove}
      />
      <Errors errors={errors} />
    </Main>
  );
};

export default CottagesContainer;
